import Button from '../../commons/button'
import icAddSquare from '../../../assets/images/id-add-square.svg'
import icTrash01Red from '../../../assets/images/ic-trash-01-red.svg'
import icTrash01Gray from '../../../assets/images/ic-trash-01-gray.svg'
import Table from '../../commons/table'
import Search from '../../commons/search'
import Toast from '../../commons/toast'
import DeleteModal from '../../commons/delete-modal'
import { TABLE_SOP_CATEGORY } from '../../../configs/sop/configTableSopCategory'
import { SopCategoryForm } from './SopCategoryForm'
import ViewList from 'components/commons/view-list'

export const SopCategory = ({
    dataList,
    isLoading,
    query,
    onChangeQuery,
    onClickItemHandler,
    onCreateHandler,
    modal,
    setModal,
    formValue,
    onChangeName,
    actionType,
    isCreating,
    isUpdating,
    isDeleting,
    isFormValid,
    onSubmitForm,
    onDelete,
    toast,
    clearToast,
    selectedItems,
    onSelectItem,
    onBulkDelete,
}) => {
    return (
        <div className='flex flex-col'>
            <div className='flex flex-row justify-between px-6 py-4 gap-3'>
                <div className='flex flex-row space-x-3'>
                    <Search value={query?.search} onSearch={(search) => onChangeQuery({ page: 1, search })} />
                    <ViewList
                        show={modal?.limit}
                        onShow={() => setModal((prev) => ({ ...prev, limit: true }))}
                        onClose={() => setModal((prev) => ({ ...prev, limit: false }))}
                        value={query?.limit}
                        onSelectSize={(limit) => onChangeQuery({ page: 1, limit })}
                    />
                </div>
                <div className='flex flex-row space-x-3'>
                    <Button
                        title={'Delete'}
                        type='danger'
                        icon={selectedItems?.length > 0 ? icTrash01Red : icTrash01Gray}
                        onClick={onBulkDelete}
                        disabled={selectedItems?.length === 0}
                    />
                    <Button title='Create Category' icon={icAddSquare} onClick={onCreateHandler} />
                </div>
            </div>
            <Table
                className='my-3'
                name={TABLE_SOP_CATEGORY.name}
                columns={TABLE_SOP_CATEGORY.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                onClickItem={(val) => onClickItemHandler(val)}
                onSelectItem={onSelectItem}
                loading={isLoading}
            />
            <SopCategoryForm
                show={modal?.form}
                onHide={() => setModal((prev) => ({ ...prev, form: false }))}
                title={`${actionType === 'CREATE' ? 'Create' : 'Edit'} SOP Category`}
                actionType={actionType}
                formValue={formValue}
                onChangeName={onChangeName}
                isFormValid={isFormValid}
                onSubmitForm={onSubmitForm}
                isLoading={isCreating || isUpdating}
            />
            <DeleteModal
                show={modal?.delete}
                onHide={() => setModal((prev) => ({ ...prev, delete: false }))}
                onDelete={onDelete}
                isLoading={isDeleting}
                text='Apakah anda yakin ingin menghapus SOP Category?'
            />
            <Toast show={toast?.isShowToast} message={toast?.message} onClose={() => clearToast()} />
        </div>
    )
}
